import { type ReactNode } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { FieldDescription } from "@/components/ui/field";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4 sm:p-6 md:p-8">
      <div className="w-full max-w-md md:max-w-3xl">
        <div className="flex flex-col gap-6">
          <Card className="overflow-hidden p-0">
            <CardContent className="grid p-0 md:grid-cols-2">
              <div className="p-6 md:p-8">
                <div className="flex flex-col items-center gap-6 text-center mb-6">
                  <img
                    src="/logo-ext.png"
                    alt="UnifiK"
                    className="w-full max-w-[220px] mx-auto"
                  />
                </div>
                {children}
              </div>
              <div className="relative hidden bg-muted md:block">
                <img
                  src="https://www.in4velocity.com/wp-content/uploads/2024/02/Material-Management.webp"
                  alt=""
                  className="absolute inset-0 h-full w-full object-cover dark:brightness-[0.2] dark:grayscale"
                />
              </div>
            </CardContent>
          </Card>
          <FieldDescription className="px-6 text-center">
            Al hacer clic en continuar, aceptas nuestros{" "}
            <a
              href="#"
              className="underline underline-offset-2 hover:text-primary"
            >
              Términos de Servicio
            </a>{" "}
            y nuestra{" "}
            <a
              href="#"
              className="underline underline-offset-2 hover:text-primary"
            >
              Política de Privacidad
            </a>
            .
          </FieldDescription>
        </div>
      </div>
    </div>
  );
}
